module.exports = __webpack_public_path__ + "static/media/homepage-video-thumbnail.2fcb1754.png";